import React from "react";
import MemberChat from "./Components";

const Chat = (props) => {

    return (
        <>
            <div className="col-lg-12">
                <div className="card card-radius">
                    <div className="header card-header custum-bg-warning rounded">
                        <h2 className="text-white">Chat</h2>
                    </div>
                    <div className="body text-center card-body-shadow">
                       
                        <div className="tab-content mt-2">
                            <MemberChat project={props?.data} members={props?.members} />
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default Chat;